






















import { defineComponent } from "@vue/composition-api";
import SafeForWorkStatusSettings from "@/components/SafeForWorkStatusSettings";

export default defineComponent({
  name: "SafeForWorkSetup",
  components: {
    SafeForWorkStatusSettings,
  },
});
